// ============================================================
// MANIC MEETER — First names
// ============================================================
// Not a translation. The office is in Germany in both languages, so Klaus is
// Klaus either way — and in English the names are half the joke.

export const FIRST_NAMES = [
  "Klaus",
  "Sabine",
  "Jürgen",
  "Monika",
  "Bernd",
  "Heike",
  "Detlef",
  "Gisela",
  "Torsten",
  "Ute",
  "Herbert",
  "Petra",
  "Rainer",
  "Gudrun",
  "Achim",
  "Bärbel",
  "Sven",
  "Kerstin",
  "Olaf",
  "Birgit",
  "Norbert",
  "Elke",
  "Hartmut",
  "Renate",
  "Uwe",
  "Margit",
  "Dieter",
  "Ingrid",
  "Kevin",
  "Chantal",
  "Justin",
  "Jessica",
  "Malte",
  "Svenja",
];
